import {
	getMetadata,
	getMetadataResolved,
	setMetadataIsLoading,
} from '@Actions/Risk.actions';
import { error } from '@innovyze/stylovyze';
import { getAssetMetadataApi } from '@Services/Risk/Risk.services';
import { MetadataResponse } from '@Types/risk.types';
import { AxiosResponse } from 'axios';
import { AnyAction } from 'redux';
import { put, retry, takeLatest } from 'redux-saga/effects';
import { t } from 'i18next';

const singleParamUniqueLimit = 100;

function* getAssetMetadataSaga(action: AnyAction) {
	yield put(
		setMetadataIsLoading({
			key: `${action.payload.assetType}-${action.payload.field}`,
			loading: true,
		}),
	);

	try {
		const response: AxiosResponse<MetadataResponse> = yield retry(
			5,
			1500,
			getAssetMetadataApi,
			action.payload.assetType,
			action.payload.field,
		);

		// Check for a valid result
		if (Object.keys(response.data).length === 0) throw new Error();

		const metadata = response.data;
		if (metadata.unique) {
			if (metadata.unique.length > singleParamUniqueLimit) {
				yield put(
					error(
						t('Too many unique values for {{field}}', {
							field: action.payload.fieldAlias,
						}),
					),
				);
				delete metadata.unique;
			} else if (metadata.unique.length === 0) {
				delete metadata.unique;
			} else {
				metadata.unique.sort((a, b) =>
					a.localeCompare(b, undefined, {
						sensitivity: 'base',
					}),
				);
			}
		} else if (metadata.range) {
			const precision =
				metadata.precision == undefined ? 0 : metadata.precision;
			if (metadata.range.max) {
				metadata.range.max =
					Math.round(metadata.range.max * Math.pow(10, precision)) /
					Math.pow(10, precision);
			}
			if (metadata.range.min) {
				metadata.range.min =
					Math.round(metadata.range.min * Math.pow(10, precision)) /
					Math.pow(10, precision);
			}
		}

		yield put(
			getMetadataResolved({
				key: `${action.payload.assetType}-${action.payload.field}`,
				value: metadata,
			}),
		);
	} catch (e) {
		yield put(
			error(
				t('{{field}} cannot be configured due insufficient data', {
					field: action.payload.fieldAlias,
				}),
			),
		);
		// yield put(getMetadataRejected());
	}

	yield put(
		setMetadataIsLoading({
			key: `${action.payload.assetType}-${action.payload.field}`,
			loading: false,
		}),
	);
}
function* watchGetMetadata() {
	yield takeLatest(getMetadata, getAssetMetadataSaga);
}

const sagaArray = [watchGetMetadata()];

export default sagaArray;
